import React, { Suspense, lazy } from "react";
import { useEffect, useState } from "react";
import "./App.scss";
import "./i18n";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import Menu from "./components/Menu";
import WhyChooseUs from "./components/WhyChooseUs";
import Gallery from "./components/Gallery";
import GoogleReviews from "./components/GoogleReviews";
import LocationMap from "./components/LocationMap";
import Footer from "./components/Footer";
import ContextContainer from "./Context/ContextContainer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SEO from "./components/SEO";

const Checkout = lazy(() => import("./components/Checkout"));
const Admin = lazy(() => import("./components/Admin"));
const Payment = lazy(() => import("./components/Payment"));
const PaymentResult = lazy(() => import("./components/PaymentResult"));
const Policies = lazy(() => import("./components/Policies"));
const Contact = lazy(() => import("./components/Contact"));
const KitchenDisplay = lazy(() => import("./components/KitchenDisplay"));

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className="scroll-to-top-btn"
        aria-label="Scroll to top"
      >
        ↑
      </button>
    )
  );
}

function App() {
  return (
    <ContextContainer>
      <BrowserRouter>
        <Navbar />
        <Suspense fallback={null}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <SEO pageKey="home" path="/" image="/images/og-main.jpg" />
                  <main>
                    <HeroSection />
                    <Menu />
                    <WhyChooseUs />
                    <Gallery />
                    <GoogleReviews />
                    <LocationMap />
                  </main>
                  <ScrollToTopButton />
                </>
              }
            />
            <Route
              path="/checkout"
              element={
                <>
                  <SEO pageKey="checkout" path="/checkout" image="/images/og-main.jpg" />
                  <main>
                    <Checkout pageMode={true} />
                  </main>
                </>
              }
            />
            <Route
              path="/admin"
              element={
                <>
                  <SEO pageKey="admin" path="/admin" image="/images/og-main.jpg" />
                  <Admin />
                </>
              }
            />
            <Route path="/payment" element={<Payment />} />
            <Route path="/payment/result" element={<PaymentResult />} />
            <Route path="/kitchen" element={<KitchenDisplay />} />
            <Route
              path="/policies"
              element={
                <>
                  <SEO pageKey="policies" path="/policies" image="/images/og-main.jpg" />
                  <Policies />
                </>
              }
            />
            <Route
              path="/contact"
              element={
                <>
                  <SEO pageKey="contact" path="/contact" image="/images/og-main.jpg" />
                  <Contact />
                </>
              }
            />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </ContextContainer>
  );
}

export default App;
